
export class EnvironmentService {

    constructor() {
        Number.prototype.padLeft = function (base, chr) {
            var len = (String(base || 10).length - String(this).length) + 1;
            return len > 0 ? new Array(len).join(chr || '0') + this : this;
        }

    }

    
    browserDetails() {
        return DetectRTC.browser;
    }

    isAndroid() {
        return DetectRTC.osName == "Android";
    }

   isIOS() {
      return DetectRTC.osName=="iOS";
    }

    isMobile() {
        return DetectRTC.isMobileDevice;
    }

    cameraCount() {
        return DetectRTC.videoInputDevices.length;
    }

    isChrome() {
        return DetectRTC.browser.isChrome;
    }

    getBrowserVersion() {
        return DetectRTC.browser.version;
    }

    canUseWebRTC() {
        return navigator.mediaDevices && navigator.mediaDevices.getUserMedia && typeof MediaRecorder === "function";
    }
    isSafari(){
        return DetectRTC.browser.isSafari;
    }
}